import ScheduleGrid from './ScheduleGrid.view';

export default ScheduleGrid;
